import React from 'react';
import Badge from '@material-ui/core/Badge';
import Typography from '@material-ui/core/Typography';

export const AVATAR_SIZE = 38;

const AvatarInitials = ({ initials, isSelected }) => (
  <Badge color="secondary">
    <div
      className={`${
        isSelected ? 'bg-blue-200' : 'bg-gray-400'
      } h-12 w-12 rounded flex items-center justify-center`}
    >
      <Typography variant="subtitle2" className="text-white">
        {initials}
      </Typography>
    </div>
  </Badge>
);

export default AvatarInitials;
